import { render, staticRenderFns } from "./LoaderDots.vue?vue&type=template&id=514e813e&"
import script from "./LoaderDots.vue?vue&type=script&lang=js&"
export * from "./LoaderDots.vue?vue&type=script&lang=js&"
import style0 from "./loader.css?vue&type=style&index=0&lang=css&"
import style1 from "./loader-dots.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports